import * as React from 'react';
import { TOptionValue, useDeviceType } from '@cian/ui-kit';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Form } from 'shared/landingBuyer/components/Form';
import { useAppDispatch } from 'shared/common/hooks';
import { selectFormStatus } from 'shared/common/selectors/form';
import { selectModalSource } from 'shared/common/selectors/modalStatus/selectModalSource';
import { selectRegions } from 'shared/common/selectors/regions';
import { sendForm } from 'shared/common/thunks';
import { EFormStatus, TFormProps } from 'shared/common/types/form';
import { EModalSource } from 'shared/common/types/modal';
import { selectUserPhone } from '../../../common/selectors/user/selectUserPhone';
import { useApplicationContext } from '../../../common/utils/applicationContext';

const PHONE_LENGTH = 10;

type TFormContainerProps = TFormProps;

export const FormContainer: React.FC<TFormContainerProps> = props => {
  const { config } = useApplicationContext();
  const marketingAgreementUrl = config.get<string>('cpd.marketingAgreementUrl') || '';
  const device = useDeviceType();

  const formStatus = useSelector(selectFormStatus);

  const formSource = useSelector(selectModalSource);

  const regions = useSelector(selectRegions);

  const userPhoneNumber = useSelector(selectUserPhone);

  const dispatch = useAppDispatch();

  const [selectValue, setSelectValue] = useState<number | null>(null);

  const [phoneValue, setPhoneValue] = useState<string>(userPhoneNumber);

  const [disabledBtn, setDisabledBtn] = useState<boolean>(true);

  const [isMarketingAgreement, toggleCheckbox] = useState<boolean>(false);

  const isDesktop = device === 'desktop';

  const isStandartTheme = false;

  const formIsLoading = formStatus === EFormStatus.Loading;

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      await dispatch(
        sendForm({
          phone: `+7${phoneValue}`,
          polygon: String(regions.find(region => region.value === selectValue)?.label),
          source: formSource === EModalSource.Consultation ? 'buyerLandingPageConsultation' : 'buyerLandingPageForm',
          legalAgreementAccepted: isMarketingAgreement,
        }),
      );
    },
    [dispatch, formSource, phoneValue, regions, selectValue, isMarketingAgreement],
  );

  const handleChangeMarketingAgreement = () => {
    toggleCheckbox(!isMarketingAgreement);
  };

  const handleSelectPolygon = useCallback((value: TOptionValue) => {
    setSelectValue(Number(value));
  }, []);

  const handleChangePhoneInput = useCallback((value: string) => {
    setPhoneValue(value);
  }, []);

  React.useEffect(() => {
    setDisabledBtn(() => !(selectValue && phoneValue && phoneValue.length === PHONE_LENGTH));
  }, [selectValue, phoneValue]);

  return (
    <Form
      phoneValue={phoneValue}
      btnIsDisabled={disabledBtn}
      formIsLoading={formIsLoading}
      onChangePhone={handleChangePhoneInput}
      onSubmit={handleSubmit}
      onSelectPolygon={handleSelectPolygon}
      regions={regions}
      isDesktop={isDesktop}
      device={device}
      isStandartTheme={isStandartTheme}
      source={formSource}
      title={props.title}
      subtitle={'Перезвоним, изучим ваш запрос и начнём подбор агента'}
      btnTitle={'Позвоните мне'}
      isChecked={isMarketingAgreement}
      toggleCheckbox={handleChangeMarketingAgreement}
      marketingAgreementUrl={marketingAgreementUrl}
      {...props}
    />
  );
};
